import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from './auth/logout/logout.component';
import { ThemeModule } from './theme/theme.module';

const routes: Routes = [
    { path: 'login', loadChildren: './auth/auth.module#AuthModule' },
    { path: 'reset-password/:token/:email', loadChildren: './reset-password/reset-password.module#ResetPasswordModule' },
    { path: 'logout', component: LogoutComponent },
    {
        'path': '',
        'loadChildren': () => ThemeModule
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/app-routing.module.ts